//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const TotalForSaleUnitsProposedWidget = ({ count }: { count: number }) => {
  return (
    <StatCard title='Total For-Sale Units Proposed' stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />} />
  );
};

export default TotalForSaleUnitsProposedWidget;
